// extracted by mini-css-extract-plugin
export var flex_auto = "PerksAndBenefits-module--flex_auto--26d9c";
export var item = "PerksAndBenefits-module--item--1be80";
export var item__blue = "PerksAndBenefits-module--item__blue--22ffb";
export var item__green = "PerksAndBenefits-module--item__green--6de13";
export var item__lime = "PerksAndBenefits-module--item__lime--02239";
export var item__orange = "PerksAndBenefits-module--item__orange--dc7ff";
export var item__purple = "PerksAndBenefits-module--item__purple--fa276";
export var item__red = "PerksAndBenefits-module--item__red--77763";
export var item_title = "PerksAndBenefits-module--item_title--9b9d1";
export var perks_container = "PerksAndBenefits-module--perks_container--1fee6";
export var perks_grid = "PerksAndBenefits-module--perks_grid--ed374";